<ion-header #header *ngIf="app.TitelleisteAnzeigen | async">
    <ion-toolbar #toolbar>
        <ion-buttons slot="start">
            <ion-menu-button *ngIf="!back" appClick (clicked)="toggleMenu()" #menuButton id="mainmenu-menu-button"></ion-menu-button>
            <ion-back-button *ngIf="back" [defaultHref]="backUrl" #backButton id="mainmenu-back-button"></ion-back-button> <!--  -->
        </ion-buttons>

        <ion-buttons slot="primary" *ngIf="app.fahrerAngemeldet | async">

            <!-- Synchronisierungs-Info derzeit noch nicht anzeigen -->
            <!-- <ion-button routerLink="/sync" *ngIf="sync && syncSymbolAnzeigen">
                <ion-icon slot="icon-only" name="sync-outline" class="animate-rotate"></ion-icon>
            </ion-button> -->

            <ion-button routerLink="/tour/aktuell" *ngIf="zeiterfassungAnzeigen">
                <ion-icon slot="icon-only" name="time" [color]="zeiterfassungColor"></ion-icon>
            </ion-button>

            <ion-button routerLink="/proglove" *ngIf="progoveAnzeigen && (app.ProGloveVerfuegbar | async)">
                <ion-icon slot="icon-only" name="qr-code" [color]="progloveColor | async"></ion-icon>
            </ion-button>

            <ion-button routerLink="/einstellungen/waage" *ngIf="waageAnzeigen && (app.waageVerfuegbar | async)">
                <ion-icon slot="icon-only" name="bluetooth" [color]="waageColor | async"></ion-icon>
                <ion-badge color="danger" *ngIf="(anzahlWiegungen | async) > 0">{{ anzahlWiegungen | async }}</ion-badge>
            </ion-button>

            <ion-button routerLink="/einstellungen/drucker" *ngIf="druckerAnzeigen && (app.druckerVerfuegbar | async)">
                <ion-icon slot="icon-only" name="print" [color]="druckerColor | async"></ion-icon>
            </ion-button>

            <ion-button routerLink="/nachrichten" *ngIf="nachrichtenAnzeigen && (app.NachrichtenSymbolInTitelleiste | async)">
                <ion-icon slot="icon-only" name="mail"></ion-icon>
                <ion-badge color="danger" *ngIf="(anzahlNeueNachrichten | async) > 0">{{ anzahlNeueNachrichten | async }}</ion-badge>
            </ion-button>

            <ion-button *ngIf="loeschenAnzeigen" appClick (clicked)="onLoeschen($event)">
                <ion-icon slot="icon-only" name="trash"></ion-icon>
            </ion-button>

            <ion-button *ngIf="menuButtonVisible" appClick (clicked)="onShowMenu($event)">
                <ion-icon slot="icon-only" name="ellipsis-vertical"></ion-icon>
            </ion-button>

        </ion-buttons>
        <ion-title><span id="page-title-span">{{ title |translate }}</span><span class="zaehler-text" *ngIf="zaehlerText">{{ zaehlerText }}</span></ion-title>
    </ion-toolbar>
</ion-header>